/**
 * Hybrid Skeleton Component
 * Automatically chooses between Tailwind and styled-components based on props.
 */

import React from "react";
import type { SkeletonProps } from "./SkeletonTypes";
import SkeletonStyled from "./styles"; // Styled-components version
import { SkeletonTailwind } from "./SkeletonTailwind"; // Tailwind version
import { needsStyledComponents } from "@sproutsocial/seeds-react-system-props";

const SkeletonHybrid = React.forwardRef<HTMLDivElement, SkeletonProps>(
  (props, ref) => {
    // Mirror the Button reference (ButtonHybrid.tsx): do NOT strip
    // width/height/borderRadius before the gate. width/height are styled-system
    // props, so a real (always-dimensioned) Skeleton — and any styled()
    // extension (injected theme/forwardedComponent) — routes to
    // styled-components, preserving styled-system dimension semantics
    // (number ≤ 1 → %, arrays → responsive) and styled() backward-compat. Only a
    // Skeleton with zero styled props uses the Tailwind path.
    if (needsStyledComponents(props)) {
      return <SkeletonStyled {...props} ref={ref} />;
    }

    // Use Tailwind version (preferred - better performance)
    return <SkeletonTailwind {...props} ref={ref} />;
  }
);

SkeletonHybrid.displayName = "Skeleton";
export default SkeletonHybrid;
